/**
 * Les niveaux d'accès d'un enfant en inclusion, dans les mots d'Éclosion
 * (VALIDÉ ÉCLOSION, 26/10/2026). Un seul endroit, pour que chaque écran de
 * l'équipe dise la même chose.
 */

import type { NiveauAcces } from './demandes';

export const NIVEAUX: readonly NiveauAcces[] = [1, 2, 3];

export const DESCRIPTION_DES_NIVEAUX: Record<NiveauAcces, { titre: string; description: string }> = {
  1: {
    titre: 'Inscription directe',
    description: 'Participe sans animateur dédié, avec quelques aménagements : ses parents l’inscrivent comme tout enfant.',
  },
  2: {
    titre: 'Avec un animateur spécialisé',
    description: 'Ne participe qu’avec un animateur spécialisé à ses côtés : chaque inscription passe par une demande, que l’administration confirme ou refuse.',
  },
  3: {
    titre: 'Accueil impossible',
    description: 'Ne peut pas être accueilli·e, même avec un animateur spécialisé : ni inscription ni demande.',
  },
};

/** « Niveau 2 — Avec un animateur spécialisé », ou « À examiner ». */
export const libelleDuNiveau = (niveau: NiveauAcces | null | undefined) =>
  niveau ? `Niveau ${niveau} — ${DESCRIPTION_DES_NIVEAUX[niveau].titre}` : 'À examiner';

/** « Léa participe sans animateur dédié… » : la description, avec le prénom de l'enfant. */
export const phraseDuNiveau = (niveau: NiveauAcces, prenom: string) => {
  const d = DESCRIPTION_DES_NIVEAUX[niveau].description;
  return `${prenom} ${d.charAt(0).toLowerCase()}${d.slice(1)}`;
};

/** Les couleurs d'une pastille, du plus libre au plus fermé. */
export const COULEUR_DU_NIVEAU: Record<NiveauAcces | 'aucun', string> = {
  aucun: 'bg-amber-100 text-amber-800',
  1: 'bg-green-100 text-green-800',
  2: 'bg-blue-100 text-blue-800',
  3: 'bg-red-100 text-red-800',
};
